import { Component, inject } from '@angular/core';
import { AuthService } from '@app/core/services/auth.service';
import { MatMenuModule } from '@angular/material/menu';
import { nl } from '@app/core/translations';

@Component({
  selector: 'app-user-avatar',
  imports: [MatMenuModule],
  templateUrl: './user-avatar.html',
  styleUrls: ['./user-avatar.scss'],
})
export class UserAvatar {
  readonly authService = inject(AuthService);
  readonly t = nl.common;

  logout() {
    this.authService.logout();
  }
}
